import type React from "react";
import { ReactComponent as Svg } from "./assets/check-circle-1.svg";
import * as styles from "./Icon.module.scss";

type CheckCircleProps = React.SVGProps<SVGSVGElement>;

export const CheckCircle = ({ className, ...props }: CheckCircleProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
